// Rào quyền phía màn hình cho khu giao vận (spec §5.1–§5.3).
//
// Đây là tầng THÔ: giấu nút cho đỡ mời gọi. Chốt chặn thật nằm ở máy chủ —
// service còn gác thêm cơ sở NHẬN hàng phải nằm trong phạm vi người bấm, thứ
// màn hình không tự biết. Đừng bao giờ coi hàm ở đây là bằng chứng an toàn.
import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";
import { useAuthV2, type Staff } from "@/lib/authv2/store";

export type PermUser = Pick<Staff, "id" | "role" | "department"> | null | undefined;

/**
 * Ba phòng đụng vào khu giao vận: lễ tân nhận–kiểm–giao, CSKH theo đơn khách
 * mình bán, hậu kỳ gửi mẫu và gửi nhà in. Khớp rào phòng ban trong service.
 */
export const PRINT_OPS_DEPTS = new Set(["reception", "cskh", "retouch"]);

/** Vai chung chung (staff/manager) còn phải đúng phòng; vai riêng thì không. */
function deptOK(u: PermUser): boolean {
  if (!u) return false;
  if (u.role === "staff" || u.role === "manager") return PRINT_OPS_DEPTS.has(u.department);
  return true;
}

export function canReadPrintOps(u: PermUser): boolean {
  return !!u && hasPermission(ACTION.PrintopsRead) && deptOK(u);
}

export function canWritePrintOps(u: PermUser): boolean {
  return !!u && hasPermission(ACTION.PrintopsWrite) && deptOK(u);
}

/** Đổi cơ sở nhận hàng: chỉ giám đốc (và quản trị tech). */
export function canReroutePrintOps(u: PermUser): boolean {
  return !!u && hasPermission(ACTION.PrintopsReroute);
}

/** Sửa cấu hình "Đơn in & hàng in" trong Cài đặt chung. */
export function canManagePrintOpsSettings(u: PermUser): boolean {
  return (
    !!u && (u.role === "admin" || u.role === "director") && hasPermission(ACTION.SettingsWrite)
  );
}

export const useCanReadPrintOps = () => useAuthV2((s) => canReadPrintOps(s.currentStaff));
export const useCanWritePrintOps = () => useAuthV2((s) => canWritePrintOps(s.currentStaff));
export const useCanReroutePrintOps = () => useAuthV2((s) => canReroutePrintOps(s.currentStaff));
export const useCanManagePrintOpsSettings = () =>
  useAuthV2((s) => canManagePrintOpsSettings(s.currentStaff));
